import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { LocaleService } from './locale.service';

@Injectable({
	providedIn: 'root',
})
export class TimeService {
	constructor(public locale: LocaleService) {}

	fromNow(timestamp: string, sold: boolean = false) {
		moment.locale(this.locale.lang);

		if (sold) {
			var deleteDate = moment.utc(moment(timestamp).add(3, 'days').format('YYYY-MM-DD HH:mm:ss').slice(0, -8) + '00:00:00');
			return moment.utc().to(deleteDate);
		} else {
			var timescale = moment(timestamp).format('DD-MM-YYYY');
			return timescale;
			// return timescale.charAt(0).toUpperCase() + timescale.slice(1);
		}
	}
}
